import React from 'react';
import Slider from "react-slick";

export default function Teams(props) {
    const colorString = Object.values(props.theme).toString();
    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }

          ]
    };
    return (
        <section className={colorString === 'true'?`customSec dark`: `customSec whiteTheme`}> 
            <div className="container">
                <div className="sectionHeading justify-content-center text-center">
                    <div className="d-block">
                        <h2>FOUNDING TEAM</h2>
                    </div>
                </div>
                <div className="teams-container">
                <Slider {...settings}>
                    <div className="row justify-content-center">
                        <div className="teams-image">
                            <img alt="" src={process.env.PUBLIC_URL + '/images/suniel-shetty.png'}  className=""></img>
                        </div>
                        <div className="teams-label row justify-content-center">
                            <div className="member-name">Suniel Shetty</div>
                            <div className="member-designation">Investor & Advisor</div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="teams-image">
                            <img alt="" src={process.env.PUBLIC_URL + '/images/Abhay.png'}  className="teams-image"></img>
                        </div>
                        <div className="teams-label row justify-content-center">
                            <div className="member-name">Abhay Aggrawal</div>
                            <div className="member-designation">CEO & Founder</div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="teams-image">
                            <img alt="" src={process.env.PUBLIC_URL + '/images/bibin-babu.png'}  className="teams-image"></img>
                        </div>
                        <div className="teams-label row justify-content-center">
                            <div className="member-name">Bibin Babu</div>
                            <div className="member-designation">Co-Founder & COO</div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="teams-image">
                            <img alt="" src={process.env.PUBLIC_URL + '/images/mo_akram.png'}  className="teams-image"></img>
                        </div>
                        <div className="teams-label row justify-content-center">
                            <div className="member-name">Mo Akram</div>
                            <div className="member-designation">Chief Technology Officer</div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="teams-image">
                            <img alt="" src={process.env.PUBLIC_URL + '/images/Gagandeep-singh.png'}  className="teams-image"></img>
                        </div>
                        <div className="teams-label row justify-content-center">
                            <div className="member-name">Gagandeep Singh</div>
                            <div className="member-designation">Director</div>
                        </div>
                    </div>
                </Slider>
                </div>
            </div>
        </section>
    )
}
